import React from 'react';

import TextLoadingSkeleton from './Components/LoadingSkeletons/TextLoadingSkeleton';
import FormLoadingSkeleton from './Components/LoadingSkeletons/FormLoadingSkeleton';
import AsyncComponent from './Components/AsyncComponent/AsyncComponent';

import Logout from './Pages/Logout/Logout';
import Blacklisted from './Pages/Blacklisted/Blacklisted';
import RecoveryEntry from './Pages/Recovery/RecoveryEntry/RecoveryEntry';
import PasswordRecoveryReset from './Pages/Recovery/PasswordRecoveryReset/PasswordRecoveryReset';
import PasswordRecoveryConfirm from './Pages/Recovery/PasswordRecoveryConfirm/PasswordRecoveryConfirm';
import LoginUserContainer from './Pages/LoginUser/LoginUserContainer';
import PostLoginContainer from './Pages/PostLogin/PostLoginContainer';

import AccountRecoveryContainer from './Pages/AccountRecovery/AccountRecoveryContainer';
import AccountRecoverySuccess from './Pages/AccountRecovery/Success/Success';

const routes = [
  {
    path: '/',
    renderFunction: props => <LoginUserContainer {...props} />,
  },
  {
    path: '/deactivated',
    renderFunction: props => <Blacklisted {...props} />,
  },
  {
    path: '/logout',
    wide: true,
    renderFunction: props => <Logout {...props} />,
  },
  {
    path: '/security-check',
    noJavascriptFallback: true,
    renderFunction: props => <PostLoginContainer {...props} />,
  },
  {
    path: '/reactivation',
    renderFunction: props => (
      <AsyncComponent
        {...props}
        loadingSkeleton={<TextLoadingSkeleton />}
        importer={() =>
          import('./Pages/AccountReactivation/AccountReactivationContainer')
        }
      />
    ),
  },
  {
    path: '/tfa/authenticator',
    renderFunction: props => (
      <AsyncComponent
        {...props}
        loadingSkeleton={<FormLoadingSkeleton />}
        importer={() =>
          import('./Pages/TwoFactorAuthApp/TwoFactorAuthAppContainer')
        }
      />
    ),
  },
  {
    path: '/tfa/backup',
    renderFunction: props => (
      <AsyncComponent
        {...props}
        loadingSkeleton={<FormLoadingSkeleton />}
        importer={() =>
          import(
            './Pages/TwoFactorAuthBackupCode/TwoFactorAuthBackupCodeContainer'
          )
        }
      />
    ),
  },
  {
    path: '/tfa/sms',
    renderFunction: props => (
      <AsyncComponent
        {...props}
        loadingSkeleton={<FormLoadingSkeleton />}
        importer={() =>
          import('./Pages/TwoFactorAuthSms/TwoFactorAuthSmsContainer')
        }
      />
    ),
  },
  {
    path: '/recovery',
    renderFunction: props => <RecoveryEntry {...props} />,
  },
  {
    path: '/recovery/password/confirm',
    renderFunction: props => <PasswordRecoveryConfirm {...props} />,
  },
  {
    path: '/recovery/password/new',
    renderFunction: props => <PasswordRecoveryReset {...props} />,
  },
  {
    path: '/recovery/account/no-access',
    renderFunction: props => <AccountRecoveryContainer {...props} />,
  },
  {
    path: '/recovery/account/forgot-credentials',
    renderFunction: props => <AccountRecoveryContainer {...props} />,
  },
  {
    path: '/recovery/account/success',
    renderFunction: props => <AccountRecoverySuccess {...props} />,
  },
];

export default routes;
